import { render } from "./BomCellItem.vue?vue&type=template&id=5bc0108a&scoped=true"
import script from "./BomCellItem.vue?vue&type=script&lang=js"
export * from "./BomCellItem.vue?vue&type=script&lang=js"

import "./BomCellItem.vue?vue&type=style&index=0&id=5bc0108a&lang=scss&scoped=true"

import exportComponent from "../../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5bc0108a"]])

export default __exports__